import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  ButtonGroup,
  DropdownButton,
  MenuItem,
  Modal,
  Checkbox,
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createHashHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";

// include action file for add merchant
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import { getMerchantType } from "../../../redux/actions/merchantActions";
import { getAllCategorys } from "../../../redux/actions/categories";
import { payoutReport, merchantPayoutDetail, markPayment, addPayouComment, getPayoutComment, getPayoutHistory } from "../../../redux/actions/reportAction";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import DatePicker from "react-date-picker";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import moment from "moment";
import loader from "../../../style/loader/loader.scss";
import "../../../style/react-datetimepicker.scss";
import { CSVLink } from "react-csv";
import {aclUtil} from "../../util"
let rand = require("random-key");
const history = createHashHistory();

const HorizontalLine = ({}) => <hr />;

const propTypes = {
  payoutReport: PropTypes.func.isRequired
};
let cityItems = [];
let isLoading = "false",
  csvData = [],
  scheduleID = [];
class MerchantPayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'MERCHANT_PAYOUTS',
      path: ["Home","Merchant Payout Report"],
      links: ["home",'report/merchant-payout' ],
      disabled: false,
      sales: [],
      csvData: "",
      markPaymentPopup : false,
      paymentData: '',
      payAmount: '',
      transactionID: '',
      isLoading: 'false',
      comment: '',
      commentPopup: false,
      historyPopup: false,
      callPopup: '',
      comments: '',
      alertMessage: '',
      payoutHistory: '',
      selectAll: true,
    };

    this.validate = this.validate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleMarkPayment = this.handleMarkPayment.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);
  }

  
  

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  // Handle input onchange
  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  validate = () => {
    let isError = false;
    const errors = {};

    if(this.state.payAmount){
      if(parseInt(this.state.payAmount) > parseInt(this.state.paymentData.totalMerchantPayout)){
        isError = true;
        this.setState({payAmountError: 'red'});
      }
    }
    return isError;
  };

  handleMarkPayment(e) {
    e.preventDefault();
    const err = this.validate();
    if(!err){
      isLoading = "true";
      if(this.state.selectAll == true && isEmpty(scheduleID)){
        if(this.state.paymentData.all_due_payout){
          this.state.paymentData.all_due_payout.map((id, index) => 
            scheduleID.push(id.scheduleID)
          )
        }
      }

      const constData = {
        scheduleID: scheduleID,
        payAmount : this.state.payAmount,
        transactionID : this.state.transactionID,
        comment: this.state.comment,
        site_id: localStorage.getItem("siteID")
      }
      // console.log(constData)
      this.props.markPayment(constData);
    }
  }

  handleComment = (e) => {
    e.preventDefault();
    if(this.state.comment){
      let postData = {
        scheduleID : this.state.paymentData.scheduleID,
        comment: this.state.comment,
        site_id: localStorage.getItem("siteID")
      }
      this.props.addPayouComment(postData);
    }else{
      this.setState({commentError: 'red'});
    }
  }

  Clear = () => {};

  handlePageChange = page => {};

  componentWillMount() {
    isLoading = "true";
    this.props.clearAlert();
    this.handleDismiss();
    this.props.payoutReport('report/merchant-payout', '' , {site_id: localStorage.getItem("siteID")});
  }
  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.props.history.push("/restrictedAccess");
    }
    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        isLoading = "false";
        this.setState({ sales: "" });
      }
    }

    if (this.props.paymentStatus !== nextProps.paymentStatus) {
      if (nextProps.paymentStatus) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.paymentStatus.message);
        isLoading = "false";
        this.handleClose();
        this.props.payoutReport('report/merchant-payout', '' , {site_id: localStorage.getItem("siteID")});
      }
    }

    if (this.props.getcommentStatus !== nextProps.getcommentStatus) {
      if (nextProps.getcommentStatus) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.getcommentStatus.message);
        isLoading = "false";
        this.handleClose();
      }
    }


    if (this.props.payout !== nextProps.payout) {
      if (nextProps.payout) {
        isLoading = "false";
        this.setState({ payout: nextProps.payout.data });
        this.handleExport(nextProps.payout.data);
      }
    }

    if (this.props.getComment !== nextProps.getComment) {
      if (nextProps.getComment) {
        isLoading = "false";
        this.setState({ comments: nextProps.getComment.data });
      }
    }

    if (this.props.getpayoutSummary !== nextProps.getpayoutSummary) {
      if (nextProps.getpayoutSummary) {
        isLoading = "false";
        this.setState({ historyPopup: true, payoutHistory: nextProps.getpayoutSummary.data});
      }
    }

    if(this.props.paymentData !== nextProps.paymentData){
      if(nextProps.paymentData){
        isLoading = "false";
        this.setState({
          markPaymentPopup: (this.state.callPopup == 'markPaymentPopup') ? true : false,
          commentPopup: (this.state.callPopup == 'commentPopup') ? true : false,
          historyPopup: (this.state.callPopup == 'historyPopup') ? true : false,
          paymentData: nextProps.paymentData.data,
          payAmount: nextProps.paymentData.data.total_due_merchant_payout,
        });

        if(nextProps.paymentData.data && nextProps.paymentData.data.all_due_payout){
          let array = [];
          nextProps.paymentData.data.all_due_payout.map((data, index) => 
            array.push(data.scheduleID)
          );
          this.setState({scheduleID: array});
        }
        
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }
  }

  handleExport = data => {
    csvData = [
      [
        '#',
        'Merchant Name',
        'Offer ID',
        'Offer Name',
        'Payment Term',
        'Gross Refund',
        'Merchant Refund',
        'Gross Sales',
        'Net Payout',
        'Term Amount',
        'Amount Remaining',
        'Due Date',
      ]
    ];

    if (!isEmpty(data)) {
      data.map((payout, index) => {
        csvData.push([
          ++index,
          payout.merchantFirstName+' '+payout.merchantLastName,
          payout.OfferID,
          payout.OfferName,
          payout.paymentTerm,
          payout.grossRefund,
          payout.refundAmount,
          payout.grossSales,
          payout.netPayout,
          payout.termAmount,
          payout.amountRemaining,
          payout.dueDate,
        ]);
      });
    }

    this.setState({ csvData: csvData });
  };

  markPayment = (e) => {
    let id = e.target.attributes.getNamedItem("data-key").value;
    let date = e.target.attributes.getNamedItem("data-date").value;
    isLoading = "true";
    this.setState({callPopup: 'markPaymentPopup'});
    this.props.merchantPayoutDetail({dueDate: date, dealID: id, site_id: localStorage.getItem("siteID")});
  }

  paymentHistory = (e) => {
    let id = e.target.attributes.getNamedItem("data-key").value;
    let date = e.target.attributes.getNamedItem("data-date").value;
    isLoading = "true";
    this.setState({callPopup: 'historyPopup'});
    this.props.getPayoutHistory({dueDate: date, dealID: id, site_id: localStorage.getItem("siteID")});
  }

  paymentComment = (e) => {
    let id = e.target.attributes.getNamedItem("data-key").value;
    let date = e.target.attributes.getNamedItem("data-date").value;
    isLoading = "true";
    this.setState({callPopup: 'commentPopup'});
    this.props.merchantPayoutDetail({dueDate: date, dealID: id, site_id: localStorage.getItem("siteID")});
    this.props.getPayoutComment({dueDate: date, dealID: id, site_id: localStorage.getItem("siteID")});
  }

  handleClose() {
    this.setState({
      markPaymentPopup: false,
      paymentData: '',
      payAmount: '',
      transactionID: '',
      comment: '',
      commentPopup: false,
      historyPopup: false,
      callPopup: '',
      commentError: '',
      scheduleID: '',
      selectAll: true,
    });

    scheduleID = [];
  }

  selectAll = (e) => {
    if(e.target.checked){
      this.setState({selectAll: true});
      if(this.state.paymentData.all_due_payout){
        this.state.paymentData.all_due_payout.map((data, index) => 
          scheduleID.push(data.scheduleID)
        )
      }
    }else{
      this.setState({selectAll: false});
      scheduleID = [];
    }
  }

  checkePaymentSchedule = (e) => {
    scheduleID = (this.state.scheduleID) ? this.state.scheduleID : [];
    let index;
    if (e.target.checked) {
      scheduleID.push(e.target.value);
    } else {
      index = scheduleID.indexOf(e.target.value)
      scheduleID.splice(index, 1)
    }

    this.setState({scheduleID : scheduleID});
  }

  render() {
    return (
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links}/>
          </div>
        </div>
    
        <div className="panel">
          <header className="panel-heading">Merchant Payout 
          <span className="pull-right">
              {this.state.csvData ? (
                <CSVLink
                  data={this.state.csvData}
                  filename={"merchant-payout-report.csv"}
                  className="btn btn-danger"
                >
                  Export CSV
                </CSVLink>
              ) : null}
            </span>
          </header>
          <div className="panel-body">
            {this.state.show &&
            this.state.alertMessage !== "" && (
              <div className="col-lg-12">
                <Alert
                  bsStyle={this.state.msgType}
                  onDismiss={this.handleDismiss}
                >
                  <strong>{this.state.msgType}:</strong>{" "}
                  {this.state.alertMessage}
                </Alert>
              </div>
            )}
            <table className="table table-hover table-bordered payout-action">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Merchant Name</th>
                  <th>Offer ID</th>
                  <th>Offer Name</th>
                  <th>Payment Term</th>
                  <th>Gross Refund</th>
                  <th>Merchant Refund</th>
                  <th>Gross Sales</th>
                  <th>Net Payout</th>
                  <th>Term Amount</th>
                  <th>Amount Remaining</th>
                  <th>Due Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {!isEmpty(this.state.payout) ? (
                  this.state.payout.map((payout, index) => (
                    <tr key={Math.random()+index}>
                      <td>{++index}</td>
                      <td>{payout.merchantFirstName} {payout.merchantLastName}</td>
                      <td>{payout.OfferID}</td>
                      <td>{payout.OfferName}</td>
                      <td>{payout.paymentTerm}</td>
                      <td>{payout.grossRefund}</td>
                      <td>{payout.refundAmount}</td>
                      <td>{payout.grossSales}</td>
                      <td>{payout.netPayout}</td>
                      <td>{payout.termAmount}</td>
                      <td>{payout.amountRemaining}</td>
                      <td>{payout.dueDate}</td>
                      <td>
                        <ButtonGroup key={Math.random()}>
                            <DropdownButton title="Action" id="bg-nested-dropdown" key={Math.random()}>
                              <MenuItem eventKey={Math.random()} data-key={payout.OfferID} data-date={payout.dueDate} onClick={this.markPayment}><i className="fa fa-eye"></i>Mark Payment</MenuItem>
                              <MenuItem eventKey={Math.random()} data-key={payout.OfferID} data-date= {payout.dueDate} onClick={this.paymentComment}><i className="fa fa-eye"></i>Add Comment</MenuItem>
                              <MenuItem eventKey={Math.random()} data-key={payout.OfferID} data-date= {payout.dueDate} onClick={this.paymentHistory}><i className="fa fa-eye"></i>View History</MenuItem>
                            </DropdownButton>
                        </ButtonGroup>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr key={Math.random()}>
                    <td colSpan="26">Data Not Available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <Modal show={this.state.markPaymentPopup} bsSize="large" onHide={this.handleClose.bind(this)} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>Make Payment</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              <Row>
                <Col lg={6} md={6} sm={12}>
                  <FormGroup>
                    <ControlLabel>Offer : {this.state.paymentData.OfferName}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <FormGroup>
                    <ControlLabel>Merchant  :  {this.state.paymentData.merchantName}</ControlLabel>
                  </FormGroup>
                </Col>
              </Row>
              
              <hr />
              
              <Row>
                <Col lg={6} md={6} sm={12}>
                  <FormGroup>
                    <h4>Offer Detail</h4>
                    <hr/>
                  </FormGroup>
                  <FormGroup>
                    <p><b>Offer ID :</b> {this.state.paymentData.OfferID}</p>
                  </FormGroup>
                  <FormGroup>
                    <p><b>Original Price :</b> {this.state.paymentData.originPrice}</p>
                  </FormGroup>
                  <FormGroup>
                    <p><b>Offer Price :</b> {this.state.paymentData.offerPrice}</p>
                  </FormGroup>
                  <FormGroup>
                    <p><b>Remittance Per Unit :</b> {this.state.paymentData.remittancePerUnit}</p>
                  </FormGroup>
                  <FormGroup>
                    <p><b>Launch Date :</b> {this.state.paymentData.launchDate}</p>
                  </FormGroup>
                  <FormGroup>
                    <p><b>End Date :</b> {this.state.paymentData.endDate}</p>
                  </FormGroup>
                  <FormGroup>
                    <p><b>Number of Vouchers Sold :</b> {this.state.paymentData.vouchers_sold}</p>
                  </FormGroup>
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <FormGroup>
                    <h4>Payment Detail</h4>
                    <hr/>
                  </FormGroup>
                  <FormGroup>
                    <p><b>Gross Sales :</b> {this.state.paymentData.grossSales}</p>
                  </FormGroup>
                  <FormGroup>
                    <p><b>Gross Refund :</b> {this.state.paymentData.grossRefund}</p>
                  </FormGroup>
                  <FormGroup>
                    <p><b>Merchant Refund :</b> {this.state.paymentData.refundAmount}</p>
                  </FormGroup>
                  <FormGroup>
                    <p><b>Gross CC Fees :</b> {this.state.paymentData.total_credit_card_fee}</p>
                  </FormGroup>
                  <FormGroup>
                    <p><b>Shipping To Merchant :</b> {this.state.paymentData.merchantShipping}</p>
                  </FormGroup>
                  <FormGroup>
                    <p><b>Term Name :</b> {this.state.paymentData.paymentTerm}</p>
                  </FormGroup>
                  <FormGroup>
                    <p><b>Site Commission :</b> {this.state.paymentData.site_commission}</p>
                  </FormGroup>
                  <FormGroup>
                    <p><b>Merchant Payout Commission (in percentage) :</b> {this.state.paymentData.percent}</p>
                  </FormGroup>
                  <FormGroup>
                    <p><b>Total Merchant Payout (shipping already included) :</b> {this.state.paymentData.totalMerchantPayout}</p>
                  </FormGroup>
                  <FormGroup>
                    <p><b>Final Merchant Payout :</b> {this.state.paymentData.finalMerchantPayout}</p>
                  </FormGroup>
                  <FormGroup>
                    <p><b>Total Term Amount Due Merchant :</b> {this.state.paymentData.total_due_merchant_payout}</p>
                  </FormGroup>
                   <FormGroup>
                    <p><b>Total Term Amount Paid Merchant :</b> {this.state.paymentData.total_term_paid_amount}</p>
                  </FormGroup>
                </Col>
              </Row>
              <FormGroup>
                <h4>Make Payment</h4>
                <hr/>
              </FormGroup>
              <Row>
                <Col lg={4} md={4} sm={12}>
                  <FormGroup>
                    <ControlLabel>Enter Amount to Pay Merchant</ControlLabel>
                    <FormControl
                        type="text"
                        name="payAmount"
                        defaultValue={(this.state.payAmount) ? this.state.payAmount : '0'}
                        onChange={this.handleChange}
                        style={{ borderColor: this.state.payAmountError }}
                    />
                  </FormGroup>
                </Col>
                <Col lg={4} md={4} sm={12}>
                  <FormGroup>
                    <ControlLabel>Enter Transaction ID (optional)</ControlLabel>
                    <FormControl
                        type="text"
                        name="transactionID"
                        value={this.state.transactionID}
                        onChange={this.handleChange}
                    />
                  </FormGroup>
                </Col>
                <Col lg={4} md={4} sm={12}>
                  <FormGroup>
                    <ControlLabel>Enter Comment</ControlLabel>
                    <FormControl
                        type="text"
                        name="comment"
                        value={this.state.comment}
                        onChange={this.handleChange}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <hr />
              <Row>
                <Col lg={12} md={12} sm={12}>
                  <table className="table table-hover table-bordered">
                    <thead>
                      <tr>
                        <th><Checkbox name="selectAll" onClick={this.selectAll} defaultChecked={this.state.selectAll}></Checkbox></th>
                        <th>Total Term Amount</th>
                        <th>Paid Term Amount</th>
                        <th>Due Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.paymentData.all_due_payout ?
                        this.state.paymentData.all_due_payout.map((due, index) => 
                          <tr key={due.scheduleID + index}>
                            <td>
                            {(scheduleID.indexOf(due.scheduleID) > -1) ? 
                            <Checkbox name={`scheduleID-${index}`} value={due.scheduleID} defaultChecked={true} onClick={this.checkePaymentSchedule}></Checkbox>
                            :
                            <Checkbox name={`scheduleID-${index}`} value={due.scheduleID} defaultChecked={this.state.selectAll} onClick={this.checkePaymentSchedule}></Checkbox>
                            }
                            </td>
                            <td>{due.totalTermAmount}</td>
                            <td>{due.totalPaidAmount}</td>
                            <td>{moment(due.dueDate).format('M-D-Y')}</td>
                          </tr>
                        )
                      :
                      <tr>
                        <td colSpan="2">Data Not Found</td>
                      </tr>
                      }
                    </tbody>
                  </table>
                </Col>
              </Row>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="success" onClick={this.handleMarkPayment}>
              Mark As Paid
            </Button>
            <Button bsStyle="default" onClick={() => history.push(`/merchant/w9info/${this.state.paymentData.merchantID}`)}>
              W9 Info
            </Button>
            <Button bsStyle="danger" onClick={this.handleClose.bind(this)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.historyPopup} onHide={this.handleClose.bind(this)} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>View History</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <table className="table table-hover table-bordered">
              <thead>
                <tr>
                  <th>Amount</th>
                  <th>Transaction ID</th>
                  <th>Comment</th>
                  <th>Paid Time</th>
                </tr>
              </thead>
              <tbody>
                {this.state.payoutHistory ?
                  this.state.payoutHistory.map((history, index) => 
                    <tr>
                      <td>{history.pay_amount}</td>
                      <td>{history.transaction_id}</td>
                      <td>{history.comment}</td>
                      <td>{moment(history.created_on).format('M-D-Y')}</td>
                    </tr>
                  )
                :
                <tr>
                  <td colSpan="2">Data Not Found</td>
                </tr>
                }
              </tbody>
            </table>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={this.handleClose.bind(this)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.commentPopup} onHide={this.handleClose.bind(this)} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>Add Comment</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormGroup>
              <ControlLabel>Offer : {this.state.paymentData.OfferName}</ControlLabel>
            </FormGroup>
            <FormGroup>
              <ControlLabel>Merchant  :  {this.state.paymentData.merchantName}</ControlLabel>
            </FormGroup>
            <FormGroup>
              <ControlLabel>Enter Comment</ControlLabel>
              <FormControl
                  type="text"
                  name="comment"
                  value={this.state.comment}
                  style={{ borderColor: this.state.commentError }}
                  onChange={this.handleChange}
              />
            </FormGroup>
            <table className="table table-hover table-bordered">
              <thead>
                <tr>
                  <th>Comment</th>
                  <th>Time</th>
                </tr>
              </thead>
              <tbody>
                {this.state.paymentData.comments ?
                  this.state.paymentData.comments.map((comment, index) => 
                    <tr>
                      <td>{comment.comment}</td>
                      <td>{moment(comment.created_at).format('M-D-Y')}</td>
                    </tr>
                  )
                :
                <tr>
                  <td colSpan="2">Data Not Found</td>
                </tr>
                }
              </tbody>
            </table>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="success" onClick={this.handleComment}>
              Submit
            </Button>
            <Button bsStyle="danger" onClick={this.handleClose.bind(this)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    error: state.reportReducer.error,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    merchantType: state.merchantReducer.merchantType,
    catData: state.categoryReducer.catData,
    payout: state.reportReducer.payout,
    paymentData: state.reportReducer.paymentData,
    paymentStatus: state.reportReducer.paymentStatus,
    getcommentStatus: state.reportReducer.getcommentStatus,
    getComment: state.reportReducer.getComment,
    getpayoutSummary: state.reportReducer.getpayoutSummary,
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    renderAlert,
    clearAlert,
    getMerchantType,
    getAllCategorys,
    merchantPayoutDetail,
    payoutReport,
    markPayment,
    addPayouComment,
    getPayoutComment,
    getPayoutHistory,
  })
)(MerchantPayout);



// WEBPACK FOOTER //
// ./src/app/views/admin/reports/MerchantPayout.js